module.exports = __webpack_public_path__ + "img/2.52124991.jpg";